import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CHALLENGES } from '../constants'

const deleteChallenge = async (id: number) => {
  await fetchAPI({
    path: `/challenges/${id}`,
    method: 'delete',
  })
}

export const useDeleteChallenge = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteChallenge, {
    async onSuccess() {
      await queryClient.refetchQueries([CHALLENGES])

      toast({
        description: t('views.admin.challenges.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
